/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
 * The InlineResponse2001 model module.
 * @module model/InlineResponse2001
 * @version v0.3
 */
export default class InlineResponse2001 {
  /**
   * Constructs a new <code>InlineResponse2001</code>.
   * @alias module:model/InlineResponse2001
   * @class
   * @param id {String}
   * @param previousStatus {String}
   * @param newStatus {String}
   * @param reason {String}
   * @param createdAt {Date}
   */
  constructor(id, previousStatus, newStatus, reason, createdAt) {
    this.id = id;
    this.previousStatus = previousStatus;
    this.newStatus = newStatus;
    this.reason = reason;
    this.createdAt = createdAt;
  }

  /**
   * Constructs a <code>InlineResponse2001</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse2001} obj Optional instance to populate.
   * @return {module:model/InlineResponse2001} The populated <code>InlineResponse2001</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse2001();
      if (data.hasOwnProperty("id"))
        obj.id = ApiClient.convertToType(data["id"], "String");
      if (data.hasOwnProperty("previous_status"))
        obj.previousStatus = ApiClient.convertToType(
          data["previous_status"],
          "String"
        );
      if (data.hasOwnProperty("new_status"))
        obj.newStatus = ApiClient.convertToType(data["new_status"], "String");
      if (data.hasOwnProperty("reason"))
        obj.reason = ApiClient.convertToType(data["reason"], "String");
      if (data.hasOwnProperty("created_at"))
        obj.createdAt = ApiClient.convertToType(data["created_at"], "Date");
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
InlineResponse2001.prototype.id = undefined;

/**
 * @member {String} previousStatus
 */
InlineResponse2001.prototype.previousStatus = undefined;

/**
 * @member {String} newStatus
 */
InlineResponse2001.prototype.newStatus = undefined;

/**
 * @member {String} reason
 */
InlineResponse2001.prototype.reason = undefined;

/**
 * @member {Date} createdAt
 */
InlineResponse2001.prototype.createdAt = undefined;
